import axios from "axios";
import { readNotificationUrl } from "../utils";

export const readNotification = async (notificationId: string) => {
  return await axios.patch(readNotificationUrl(notificationId));
};
